import { FC, useEffect, useState } from "react";
import { Radio, Button, Modal, Spin } from "antd";
import { map , cloneDeep} from "lodash";
import { useLocation } from "react-router-dom";

import SimpleSelect from "@components/simpleSelect/simpleSelect";
import HighCostPatientService from "@services/high-cost-patient.service";
import commonService from "@services/common.service";
import "./filter.scss";
import { radioLables } from "../highCostPatientConstant";
import { formatDisplayDate } from "@utils/helpers";
import { useHighCostPatientStore } from "@stores/highCostPatientStore";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";

export enum filterType {
  OFFICE = "office",
  INSURANCE = "insurance",
  PAGINATION = "pagenation",
  CALENDAR = "calendar",
}
interface FilterProps {
  selectedOffice: any;
  setSelectedOffice: (x: any) => void;
  paginationFilterValue: any;
  setPaginationFilterValue: (x: any) => void;
  selectedInsurance: any;
  setSelectedInsurance: (x: any) => void;
  refreshDate: any;
  selectedRegion: any;
  setSelectedRegion: (x: any) => void;
  setBuildDone: (x: any) => void;
  setLoader: (x: any) => void;
  getTableData : any
  currentPage : any;
  setCurrentPage : (x: any) => void;
  activeTab : any;
  dropdownValueChanged : boolean;
  setDropdownValueChanged : (x: any) => void;
  initialBuild: boolean,
  setInitialBuild: (x: any) => void
}

const Filter: FC<FilterProps> = ({
  selectedOffice,
  setSelectedOffice,
  selectedInsurance,
  setSelectedInsurance,
  paginationFilterValue,
  setPaginationFilterValue,
  refreshDate,
  selectedRegion,
  setSelectedRegion,
  setBuildDone,
  setLoader,
  getTableData,
  currentPage,
  setCurrentPage,
  activeTab,
  dropdownValueChanged,
  setDropdownValueChanged,
  initialBuild,
  setInitialBuild
}) => {

  const regionLst = useHighCostPatientStore((state) => state.regionLst);
  const setRegionLst = useHighCostPatientStore((state) => state.setRegionLst);
  const insuranceLst = useHighCostPatientStore((state) => state.insuranceLst);
  const setInsuranceLst = useHighCostPatientStore((state) => state.setInsuranceLst);
  const officeNameLst = useHighCostPatientStore((state) => state.officeNameLst);
  const setOfficeNameLst = useHighCostPatientStore((state) => state.setOfficeNameLst);
  const columnData= useHighCostPatientStore((state) => state.columnData);
  const setColumnData = useHighCostPatientStore((state) => state.setColumnData);
  const [dropdownLoader, setDropdownLoader] = useState<{regionLoader : boolean ; officeLoader: boolean; insuranceLoader: boolean }>({regionLoader : false , officeLoader: false, insuranceLoader: false });
  const location: any = useLocation();

  useEffect(() => {
    //to run the build api once initially with the default value as All in all dropdowns 
    if(refreshDate && !selectedRegion?.label && !selectedOffice?.label && !selectedInsurance){
      calculateRank({region : 'ALL' , office : 'ALL' , insurance : 'ALL'});
      setInitialBuild(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[refreshDate])

  useEffect(() => {
    console.log("filter.useEffect1");
    if (!location?.state?.apiCallNotNeeded || regionLst?.length <= 0) {
      //to call the region dropdown once and set its default value as ALL
      setDropdownLoader({ ...dropdownLoader, regionLoader: true });
      commonService.getRegion({ timePeriod: refreshDate ? formatDisplayDate(refreshDate, "", "dataRefreshDateFormat") : "" }).subscribe({
        next: (response: any) => {
          const newRegionLst = [];
          response.data.region.forEach((option: any) => {
            newRegionLst.push({
              value: option.value,
              label: option.title,
              title: option.title,
            });
          });
          newRegionLst.unshift({ value: "ALL", title: "All Region", label: "All Region" });
          setRegionLst(newRegionLst);
          setSelectedRegion({ value: "ALL",title: "All Region", label: "All Region" });
          setDropdownValueChanged(true);
          fetchOfficeDropdown({ regions: [] });
          setDropdownLoader({ ...dropdownLoader, regionLoader: false });
        },
        error: (error) => {
          setRegionLst([]);
          setDropdownLoader({ ...dropdownLoader, regionLoader: false });
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchOfficeDropdown = ({regions = [selectedRegion?.value] } : any) => {
    setDropdownLoader({ ...dropdownLoader, officeLoader: true });
    //to call the office dropdown once and set its default value as ALL
    commonService.getOfficeDropdown({ timePeriod: refreshDate ? formatDisplayDate(refreshDate, "", "dataRefreshDateFormat") : "" , regions : regions }).subscribe({
      next: (response: any) => {
        const newOfficeLst = [];
        response.data.office.forEach((option: any) => {
          newOfficeLst.push({
            value: option.value,
            label: option.title,
            title: option.title,
          });
        });
        newOfficeLst.unshift({ value: "ALL", title: "All Office", label: "All Office" });
        setOfficeNameLst(newOfficeLst);
        setSelectedOffice({ value: "ALL", title: "All Office", label: "All Office" });
        setDropdownValueChanged(true);
        fetchInsuranceDropdown({officeIds : []})
        setDropdownLoader({ ...dropdownLoader, officeLoader: false });
      },
      error: (error) => {
        setOfficeNameLst([]);
        setDropdownLoader({ ...dropdownLoader, officeLoader: false });
      },
    });
  } 

  const fetchInsuranceDropdown = ({ officeIds = [selectedOffice.value] }) => {
    setDropdownLoader({ ...dropdownLoader, insuranceLoader: true });
    //to call the insurance dropdown once and set its default value as ALL
    commonService.getInsuranceDropdown({ timePeriod: refreshDate ? formatDisplayDate(refreshDate, "", "dataRefreshDateFormat") : "", officeIds: officeIds }).subscribe({
      next: (response: any) => {
        let newInsuranceLst: any = response.data?.insurance?.filter((insur: any) => insur);
        if (newInsuranceLst.length > 0) {
          newInsuranceLst = newInsuranceLst.map((value: string) => {
            return {
              value: value,
              label: value,
              title: value,
            };
          });
          newInsuranceLst.unshift({ value: "ALL", label: "All Insurance", title: "All Insurance" });
          setSelectedInsurance("ALL");
          setDropdownValueChanged(true);
        } else {
          info(`No claims found for the selected options`);
        }
        setInsuranceLst(newInsuranceLst);

        setDropdownLoader({ ...dropdownLoader, insuranceLoader: false });
      },
      error: (error) => {
        setInsuranceLst([]);
        setDropdownLoader({ ...dropdownLoader, insuranceLoader: false });
      },
    });
  };

  const calculateRank = ({region = selectedRegion.label, office = selectedOffice.label, insurance = selectedInsurance}) => {
    //to calculate ranks and to clear previous table data and  fetch the new table data api once build api is success and disable the calculate rank button 
    setLoader(true);
    HighCostPatientService.getBuild({
      timePeriod: refreshDate ? formatDisplayDate(refreshDate, "", "dataRefreshDateFormat") : "",
      region: region === "All Region" ? "ALL" : region,
      office: office === "All Office" ? "ALL" : office,
      insurance: insurance,
    }).subscribe({
      next: (response: any) => {
        useHighCostPatientStore.getState().clearTableData();
        resetSort();
        setBuildDone(true);
        getTableData({page : 1 , sortBy : 'none' , sortType : 'none' , searchOn : {}});
        setLoader(false);
        setDropdownValueChanged(false);
      },
      error: (error) => {
        setBuildDone(true);
        setLoader(false);
      },
    });
  };

  const resetSort = () => {
    // to reset the sort of previous build table so the newly build table will have default sort as current rank ascend state
    const data = cloneDeep(columnData['Part A']);
    if(data.length > 0) {
      data.forEach((col : any) => {
        if(col.dataIndex === 'current_rank'){
          col.sortOrder = 'ascend';
        } else {
          col.sortOrder = undefined;
        }
      })
      setColumnData({"Part A" : data , "Part B" : data , "Part D" : data , "Total" : data});
    }
  }
  
  return (
    <div className="filter-container">
      <div className="filter-container__wrapper">
        <div>
          <SimpleSelect
            handleSelect={(value: string, option: any) => {
              setSelectedRegion(option);
              setSelectedOffice({});
              setDropdownValueChanged(true);
              setInitialBuild(false);
              fetchOfficeDropdown({ regions: option.value !== "ALL" ? [option.value] : [] });
            }}
            value={selectedRegion.value}
            options={regionLst}
            loadingOptions={dropdownLoader.regionLoader}
            placeholder={`Select Region`}
            style={{ minWidth: 220, maxWidth: 350 }}
          />
        </div>
        <div>
        <Spin spinning={dropdownLoader.officeLoader} indicator={<HealthemSpinner/>}>
          <SimpleSelect
            handleSelect={(value: string, option: any) => {
              setSelectedOffice(option);
              setSelectedInsurance(undefined);
              setInitialBuild(false);
              setDropdownValueChanged(true);
              fetchInsuranceDropdown({ officeIds: option.value !== "ALL" ? [option.value] : [] });
            }}
            value={selectedOffice.value}
            options={officeNameLst}
            loadingOptions={!insuranceLst || dropdownLoader.officeLoader}
            placeholder={`Select Office`}
            disabled={!selectedRegion.value}
            // minWidth={true}
            style={{ minWidth: 220, maxWidth: 350 }}
          />
        </Spin>
        </div>
        <div>
          <Spin spinning={dropdownLoader.insuranceLoader} indicator={<HealthemSpinner />}>
            <SimpleSelect
              handleSelect={(value: string) => {
                setSelectedInsurance(value);
                setInitialBuild(false);
                setDropdownValueChanged(true);
              }}
              value={selectedInsurance}
              options={insuranceLst}
              disabled={!selectedOffice.value}
              loadingOptions={dropdownLoader.insuranceLoader}
              placeholder={`Select Insurance`}
              style={{ minWidth: 220, maxWidth: 350 }}
            />
          </Spin>
        </div>
        <div>
          <Button key="submit" className="filter-container_submit" type="primary" disabled={initialBuild ? initialBuild : (!selectedOffice.value || !selectedInsurance || !dropdownValueChanged)} onClick={() => {calculateRank({});setInitialBuild(false);}}>
            Calculate Rank
          </Button>
        </div>
      </div>

      <div className="filter-container__radio--select">
        <Radio.Group
          defaultValue={paginationFilterValue}
          size="large"
          onChange={(e) => {
            setPaginationFilterValue(e.target.value);
            setCurrentPage({"Part A" : 1 , "Part B" : 1 , "Part D" : 1 , "Total" : 1});
            getTableData({topVal : e.target.value !== "ALL" , page : 1})
          }}
        >
          {map(radioLables, (rad) => (
            <Radio.Button key={rad.label} value={rad.value}>
              {rad.label}
            </Radio.Button>
          ))}
        </Radio.Group>
      </div>
    </div>
  );
};

export default Filter;

const info = (text: string) => {
  Modal.info({
    title: "NO DATA FOUND",
    maskClosable: false,
    content: (
      <div>
        <p>{text}</p>
      </div>
    ),
  });
};
